import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { FirestoreDataService } from 'src/app/core/services/firestore-data/firestore-data.service';
import { UrlRegistry } from 'src/app/custom/model/url-registry.model';

@Injectable({
  providedIn: 'root'
})
export class UrlRegistryService extends FirestoreDataService<UrlRegistry> {
  constructor(afs: AngularFirestore) {
    super("UrlRegistry", afs);
  }
}
